import { datadogRum } from "@datadog/browser-rum";

import { IS_DATADOG_ENABLED } from "./lib/analytics/datadog";

const reportWebVitals = (onPerfEntry?: () => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import("web-vitals").then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onINP(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
  if (IS_DATADOG_ENABLED) {
    import("web-vitals").then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      onCLS((metric) => datadogRum.addTiming("cls", metric.value));
      onINP((metric) => datadogRum.addTiming("inp", metric.value));
      onFCP((metric) => datadogRum.addTiming("fcp", metric.value));
      onLCP((metric) => datadogRum.addTiming("lcp", metric.value));
      onTTFB((metric) => datadogRum.addTiming("ttfb", metric.value));
    });
  }
};

export default reportWebVitals;
